<template>
	<section id="storeMap" class="bg-white  will-change" :data-scroll-section="inner == 'false'">
		<div class="mb-12 pt-10" v-if="blockData.title">
            <h2 class="text-4xl xl:text-heading text-center tracking-[2px] leading-none px-8  mb-7 w-full" v-html="blockData.title"></h2>
        </div>

		<div class="relative h-[67vh] z-[1]">

			<div class="mx-content relative h-full">
				<button v-if="isMobile" type="button" class="grid place-items-center bg-white rounded p-4 absolute left-8 top-8 z-10 xl:hidden" @click="showSidebar = true">
					<span class="bg-navy-blue-01 block my-[3px] w-4 h-[1px]"></span>
					<span class="bg-navy-blue-01 block my-[3px] w-4 h-[1px]"></span>
					<span class="bg-navy-blue-01 block my-[3px] w-4 h-[1px]"></span>
				</button>

				<div v-show="showSidebar" ref="sidebar" class="sidebar scroll-just-this bg-white xl:bg-opacity-90 rounded  w-full  md:w-[300px] max-h-[100%] xl:max-h-[calc(100%-32px)] overflow-y-auto absolute left-0 top-0 md:left-4 md:top-4 z-10">

					<div class="flex items-start py-4" v-if="isMobile">
						<div class="flex items-start ">
							<div class="grid place-items-center self-start px-6">
								<span class="bg-navy-blue-01 block my-[3px] w-4 h-[1px]"></span>
								<span class="bg-navy-blue-01 block my-[3px] w-4 h-[1px]"></span>
								<span class="bg-navy-blue-01 block my-[3px] w-4 h-[1px]"></span>
							</div>
							<div class="w-1/2">
								<div class="text-navy-blue-01 mb-3">{{ __('Store List', 'ccave') }}</div>
								<div class="text-navy-blue-02 text-xs">{{ __('Type in what you need to or search categories below', 'ccave') }}</div>
							</div>
						</div>

						<button type="button" class="openShops flex-shrink-0 grid place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 ml-auto mr-4 w-10 h-10" @click="showSidebar = false">
							<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="white"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12" /></svg>
						</button>
					</div>

					<div class="flex items-center border-b border-light-grey mb-8 xl:mb-0 px-6 py-4 w-full">
						<svg class="mr-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M7.25003 2.39961C4.57145 2.39961 2.40003 4.57103 2.40003 7.24961C2.40003 9.92819 4.57145 12.0996 7.25003 12.0996C9.92861 12.0996 12.1 9.92819 12.1 7.24961C12.1 4.57103 9.92861 2.39961 7.25003 2.39961ZM1.60003 7.24961C1.60003 4.1292 4.12962 1.59961 7.25003 1.59961C10.3704 1.59961 12.9 4.1292 12.9 7.24961C12.9 10.37 10.3704 12.8996 7.25003 12.8996C4.12962 12.8996 1.60003 10.37 1.60003 7.24961Z" fill="#BFBFBF"/>
						<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6792 10.6797C10.8354 10.5234 11.0887 10.5234 11.2449 10.6797L14.2824 13.7172C14.4386 13.8734 14.4386 14.1267 14.2824 14.2829C14.1262 14.4391 13.873 14.4391 13.7168 14.2829L10.6792 11.2453C10.523 11.0891 10.523 10.8359 10.6792 10.6797Z" fill="#BFBFBF"/>
						</svg>
						<input class="border-none focus:outline-none" type="text" v-model="searchQuery" :placeholder="getSearchString()" />
					</div>

					<div v-for="( category, index ) in categoriesForMenu" :key="index" class="flex flex-col items-center border-b border-light-grey mb-8 xl:mb-0 w-full text-sm">
						<button  class="openShops flex items-center rounded px-6 py-4 cursor-pointer w-full" type="button" @click="showMenuCategory(category);">
							<img :src="category.data.fields.icon.url" :alt="category.data.fields.icon.alt" />
							<div class="flex items-center ml-4 mr-auto">
								<div class="text-navy-blue-01 font-bold text-left" v-html="category.name"></div>
								<div class="text-navy-blue-03 text-left ml-2" >( {{getPlacesCount(category)}} )</div>
							</div>
							<svg v-if="activeMenuCategory !== category" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M13 6L8 11L3 6" stroke="#001E31" stroke-width="1.2" stroke-linecap="square"/>
							</svg>

							<svg v-if="activeMenuCategory === category" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M3 11L8 6L13 11" stroke="#001E31" stroke-width="1.2" stroke-linecap="square"/>
							</svg>
						</button>
						<div v-show="activeMenuCategory === category" :class="{'block w-full active' : activeMenuCategory === category , 'hidden' : !activeMenuCategory}">
							<div v-for="(place, index) in categoryPlaces(category.id)" :key="index" @click="openPopup(place); closeSidebar();" class="border-t border-light-grey cursor-pointer">
								<div :class="{'bg-light-blue-01' : activeStore === place}" class="form-control form-control--map flex items-center py-4 px-6">
									<img class="max-w-[32px]" :src="place.store[0].fields.iconlogo.url" :alt="place.store[0].fields.iconlogo.alt"/>
									<div class="flex flex-col ml-4 mr-auto text-sm">
										<span class="text-navy-blue-01 font-bold text-left">{{ place.store[0].post_title }}</span>
										<span class="text-navy-blue-03 text-left">{{ place.store[0].store_neighbourhood.name }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>




				</div>

				<!-- map -->
				<div id="map" class="rounded-lg" style="height: 100%"></div>
				<!-- map -->
			</div>

			<div class="flex items-center " ref="popup">
				<div v-if="activeStore">
					<img :src="activeStore.store[0].fields.image.url" :alt="activeStore.store[0].fields.image.alt"/>
					<h4 class="font-ginger text-sm text-navy-blue-01 font-bold leading-snug mb-1 mt-3 "  v-html="activeStore.store[0].post_title"></h4>
					<span v-if="ifWorkHours(activeStore)" id="hours-title" class="mr-1 text-xs py-[5px]">{{ getStoreStatus() }}</span><span v-show="activeDayHours.openedclosed">{{ getDay() }}</span>
					<div v-if="ifWorkHours(activeStore) && activeStore.store[0].fields.image && activeStore.store[0].fields.text !== ''" class="flex items-center border-t border-light-grey text-xs text-dark-grey cursor-pointer py-[10px]" @click.stop.prevent="showStoreSlide()">{{ __('Show more info', 'ccave') }}
						<svg class="ml-auto" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M6 3L11 8L6 13" stroke="#BFBFBF" stroke-width="1.2" stroke-linecap="square"/>
						</svg>
					</div>
				</div>
			</div>

			<div class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap">
				<span>{{ __('Click on the interest point or zoom in to view more', 'ccave') }}</span>
			</div>

			<div
				:class="{ 'xyz-in z-[51] active-card': showSlide, 'xyz-out z-[40]': !showSlide }"
				class="card-toponyms--slide scroll-just-this fixed right-0 top-0 bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-full overflow-y-auto invisible"
				xyz="fade right-100% duration-4"
				ref="slideCard"
				data-scroll data-scroll-sticky data-scroll-target="#storeMap"
				v-on-clickaway="clickAwaySlide"
			>
				<button type="button" @click="hideStoreSlide()" class="grid place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 w-10 h-10 absolute right-6 top-6">
					<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="white"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12" /></svg>
				</button>
				<div class="pb-10" v-if="activeStore">
					<div class="overflow-hidden h-auto max-h-[34vh]">
						<img class="object-cover w-full" :src="activeStore.store[0].fields.image.sizes.customslide" :alt="activeStore.store[0].fields.image.alt">
					</div>

					<div class="p-8">
						<h4 class="text-2xl tracking-[1px] mb-6" v-html="activeStore.store[0].post_title"></h4>
						<div class="text-sm" v-html="activeStore.store[0].fields.text"></div>
					</div>

					<div class="p-8 mb-9" v-if="activeStore.store[0].store_neighbourhood">
						<dt class="tracking-desk text-sm leading-tight uppercase mb-5">{{ __('LOCATION', 'ccave') }}</dt>
							<dd class="flex">
								<div>
									<svg class="mr-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
											stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
										<path
											d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
											stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
								</div>
								<div v-html="activeStore.store[0].store_neighbourhood.name"></div>
							</dd>
					</div>

					<div class="px-8 mb-9" v-if="activeStore.store[0].fields.work_hours">
						<dt class="tracking-desk text-sm leading-tight uppercase mb-5">{{ __('WORK HOURS', 'ccave') }}</dt>
							<div class="group inline-block relative">
								<button class="flex flex-col bg-gray-300 text-gray-700 font-semibold pr-2 px-4 w-full">
									<div class="flex items-center w-full">
										<svg class="mr-4" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M12 22.6208C16.9706 22.6208 21 18.5875 21 13.6121C21 8.63682 16.9706 4.60352 12 4.60352C7.02944 4.60352 3 8.63682 3 13.6121C3 18.5875 7.02944 22.6208 12 22.6208Z" stroke="#405664" stroke-width="1.2" stroke-linecap="square"/>
											<path d="M12 8.60742V13.6122L15 16.6151" stroke="#405664" stroke-width="1.2" stroke-linecap="square"/>
											<path d="M2 5.60444L5 2.60156M19 2.60156L22 5.60444L19 2.60156Z" stroke="#405664" stroke-width="1.2" stroke-linecap="square"/>
										</svg>
										<span id="hours-title" class="mr-1 text-sm py-[5px]">{{ getStoreStatus() }}</span><span v-show="activeDayHours.openedclosed">{{ getDay() }}</span>
										<svg class="fill-current h-4 w-4 ml-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
											<path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
										</svg>
									</div>
								</button>
								<ul class="bg-white absolute hidden group-hover:block w-full z-30">
									<li class="text-sm px-4 py-2" v-if="isStoreOpen('monday')" >{{ __('Monday:', 'ccave') }} {{ formatTime(activeStore.store[0].fields.work_hours['monday'].open) }} - {{ formatTime(activeStore.store[0].fields.work_hours['monday'].close) }}</li><li v-else>{{ __('Monday: Closed', 'ccave') }}</li>
									<li class="text-sm px-4 py-2" v-if="isStoreOpen('tuesday')" >{{ __('Tuesday:', 'ccave') }} {{ formatTime(activeStore.store[0].fields.work_hours['tuesday'].open) }} - {{ formatTime(activeStore.store[0].fields.work_hours['tuesday'].close) }}</li><li v-else>{{ __('Tuesday: Closed', 'ccave') }}</li>
									<li class="text-sm px-4 py-2" v-if="isStoreOpen('wednesday')" >{{ __('Wednesday:', 'ccave') }} {{ formatTime(activeStore.store[0].fields.work_hours['wednesday'].open) }} - {{ formatTime(activeStore.store[0].fields.work_hours['wednesday'].close) }}</li><li v-else>{{ __('Wednesday: Closed', 'ccave') }}</li>
									<li class="text-sm px-4 py-2" v-if="isStoreOpen('thursday')" >{{ __('Thursday:', 'ccave') }} {{ formatTime(activeStore.store[0].fields.work_hours['thursday'].open) }} - {{ formatTime(activeStore.store[0].fields.work_hours['thursday'].close) }}</li><li v-else>{{ __('Thursday: Closed', 'ccave') }}</li>
									<li class="text-sm px-4 py-2" v-if="isStoreOpen('friday')" >{{ __('Friday:', 'ccave') }} {{ formatTime(activeStore.store[0].fields.work_hours['friday'].open) }} - {{ formatTime(activeStore.store[0].fields.work_hours['friday'].close) }}</li><li v-else>{{ __('Friday: Closed', 'ccave') }}</li>
									<li class="text-sm px-4 py-2" v-if="isStoreOpen('saturday')" >{{ __('Saturday:', 'ccave') }} {{ formatTime(activeStore.store[0].fields.work_hours['saturday'].open) }} - {{ formatTime(activeStore.store[0].fields.work_hours['saturday'].close) }}</li><li v-else>{{ __('Saturday: Closed', 'ccave') }}</li>
									<li class="text-sm px-4 py-2" v-if="isStoreOpen('sunday')" >{{ __('Sunday:', 'ccave') }} {{ formatTime(activeStore.store[0].fields.work_hours['sunday'].open) }} - {{ formatTime(activeStore.store[0].fields.work_hours['sunday'].close) }}</li><li v-else>{{ __('Sunday: Closed', 'ccave') }}</li>
								</ul>
							</div>
					</div>

					<div v-show="activeStore.store[0].fields.gallery" class="toponym-swiper swiper-container h-auto max-h-[25vh]" ref="slideSlider">
						<div class="swiper-wrapper">
							<div v-for="( slide, index ) in activeStore.store[0].fields.gallery" :key="index" class="swiper-slide" >
								<img class="object-cover w-full h-full" :src="slide.sizes.toponymslide" :alt="slide.alt">
							</div>
						</div>
					</div>
					<a class="block bg-navy-blue-01 rounded-sm text-xs tracking-little uppercase text-center text-white mx-8 py-[18px] w-[calc(100%-64px)] mt-8" v-if="activeStore.store[0].fields.cta" :href="activeStore.store[0].fields.cta.url" :target="activeStore.store[0].fields.cta.target">{{ __('VISIT WEBSITE', 'ccave') }}</a>
				</div>
			</div>

		</div>

	</section>
</template>

<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css"
import centerOfMass from "@turf/center-of-mass";
import { format, parseISO } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'
import getDay from 'date-fns/getDay'
import Swiper from 'swiper/bundle';
import { mixin as clickaway } from 'vue-clickaway'
export default {

	name: "StoresMap",
	mixins: [ clickaway ],
	data() {
		return {
			activeStore: false,
			showSlide: false,
			showSidebar: true,
			map: false,
			popup: false,
			searchQuery: "",
			legendShow: false,
			categories: [],
			activeMenuCategory: false,
			activeDayHours: false,

			slideSlider: null,
			slideSliderOptions: {
				slidesPerView: 2,
				spaceBetween: 16,
				freeMode: true,
			},
		};
	},
	mounted() {
		this.getStoresCategories()

		mapboxgl.accessToken = this.blockData.map.map_settings.access_token;
		this.map = new mapboxgl.Map({
			container: "map", // container ID
			/* style: this.blockData.map.map_settings.style */  // style URL
			style: 'mapbox://styles/aleksandarstojsin/ckvqewxb38dz814pf4rqiypte',
			center: this.blockData.map.map_settings.center, // starting position
			zoom: this.blockData.map.map_settings.zoom, // starting zoom
			pitch: this.blockData.map.map_settings.pitch,
			bearing: this.blockData.map.map_settings.bearing,
			cooperativeGestures: true,
            attributionControl: false
		});

		this.map.addControl(new mapboxgl.NavigationControl());
		this.map.scrollZoom.disable();

		this.popup = new mapboxgl.Popup({
			closeButton: false,
			closeOnClick: true,
			/* offset: [0, -15] */
		});

		this.map.on("load", () => {
			this.addDataLayer()
		})

		if ( this.$root.isMobile ) {
			this.showSidebar = false
		}

		/* this.blockData.map.markers.forEach(marker => {
			console.log("Type: " + marker.select + " " + "Name: " + marker.store[0].post_title + " " +  "Category " + marker.store[0].store_categories[0].name + "cat id " + marker.store[0].store_categories[0].term_id  )
		}) */

		this.$refs.sidebar.addEventListener('mouseenter', (e) => {
			this.$root.scroll.stop()
		})
		this.$refs.sidebar.addEventListener('mouseleave', (e) => {
			this.$root.scroll.start()
		})
	},
	watch: {
		showSlide: function (val) {	
			if ( val ) { 
				this.$root.scroll.stop() 
			} else { 
				this.$root.scroll.start()	
			} 
		}
	},
	computed: {
		categoriesForMenu() {
			let results = []
			let places = []
			if ( this.searchQuery !== "" ) {
				let regex = new RegExp('(' +this.searchQuery + ')', 'i')
				places = this.blockData.map.markers.filter(marker => marker.select === 'Store' && marker.store[0].post_title.match(regex) )

				this.categories.forEach(cat => {
					places.forEach(place => { if ( place.store[0].store_categories[0].term_id === cat.id ) { results.push(cat) }})
				})

			} else {
				places = this.blockData.map.markers.filter(place => place.select === "Store" && place.store[0].store_categories[0])

				places.forEach(place => {
					this.categories.forEach(cat => {
						if ( cat.id === place.store[0].store_categories[0].term_id ) {
							results.push(cat)
						}
					})
				})
				results = results.map(result => result).filter((value, index, self) => self.indexOf(value) === index)
			}
			return results
		},
    },
	methods: {
		clickAwaySlide() {
			this.showSlide = false
		},
		addDataLayer() {

			let clusterData = {
				type: 'ClusterData',
				crs: {},
				features: []
			}

			this.blockData.map.markers.forEach((marker, index) => {
				let mapData = JSON.parse(marker.map_data);
				if (mapData.geometry.type === "Polygon") {
					this.map.addSource("polygon" + index, {
						type: "geojson",
						data: mapData
					});

					this.map.addLayer({
						id: "fill" + index,
						type: "fill",
						source: "polygon" + index,
						layout: {},
						paint: {
							"fill-color": "#0080ff", // mora boja i opacity na nula da bi bilo transparentno, amozda moze i drugacije
							"fill-opacity": 0.1
						}
					});

					this.map.addLayer({
						id: "outline" + index,
						type: "line",
						source: "polygon" + index,
						layout: {},
						paint: {
							"line-color": "#FFF",
							"line-width": 0
						}
					});
					var comPt = centerOfMass(mapData);

					this.map.addSource("label" + index, {
						type: "geojson",
						data: comPt
					});

					this.map.addLayer({
						id: "label-style" + index,
						type: "symbol",
						source: "label" + index,
						layout: {
							"text-field": marker.name,
							'text-font': ["Canela Regular", "Open Sans Semibold", "Arial Unicode MS Bold"],
							"icon-allow-overlap": true,
							"text-allow-overlap": true,
						},
						paint: {
							"text-color": "white "
						}
					});
				} else {
					mapData.properties = marker
					clusterData.features.push(mapData)
				}


			});

			// Cluster data
			this.map.addSource('stores', {
				type: 'geojson',
				data: clusterData,
				cluster: true,
				maxzoom: 20,
				clusterMaxZoom: 30, // Max zoom to cluster points on
				clusterRadius: 40, // Radius of each cluster when clustering points (defaults to 50)
				/* tolerance: 0 */
			});

			this.map.addLayer({
				id: 'clusters',
				type: 'circle',
				source: 'stores',
				tolerance: 0,
				filter: ['has', 'point_count'],
				paint: {
				// Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
				// with three steps to implement three types of circles:
				//   * Blue, 20px circles when point count is less than 100
				//   * Yellow, 30px circles when point count is between 100 and 750
				//   * Pink, 40px circles when point count is greater than or equal to 750
				'circle-color': [
					'step',
					['get', 'point_count'],
					'#FFFFFF',
					100,
					'#FFFFFF',
					750,
					'#FFFFFF'
				],
				'circle-radius': [
					'step',
					['get', 'point_count'],
					20,
					100,
					30,
					750,
					40
				]
				}
			})

			this.map.addLayer({
				id: 'cluster-count',
				type: 'symbol',
				source: 'stores',
				filter: ['has', 'point_count'],
				layout: {
				'text-field': '{point_count_abbreviated}',
				'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
				'text-size': 12,
				"text-allow-overlap": true,
				}
			})

			this.map.addLayer({
				id: 'unclustered-point',
				type: 'symbol',
				source: 'stores',
				filter: ['!', ['has', 'point_count']],
				layout: {
 					"icon-image":  [ 'get', 'term_id', [ 'at', 0, [ 'get', 'store_categories', [ 'at', 0, [ 'get', 'store' ] ] ] ] ] , 
					"icon-anchor": "bottom",
					"icon-allow-overlap": true,
				},
			})

			this.map.on('click', 'clusters', (e) => {
				const features = this.map.queryRenderedFeatures(e.point, {
					layers: ['clusters']
				})
				const clusterId = features[0].properties.cluster_id
				this.map.getSource('stores').getClusterExpansionZoom(
					clusterId,
					(err, zoom) => {
						if (err) return;
					
						this.map.easeTo({
							center: features[0].geometry.coordinates,
							zoom: zoom
						})
					}
				)
			})

			this.map.on('click', 'unclustered-point', (e) => {
				const coordinates = e.features[0].geometry.coordinates.slice()
				e.features[0].properties.store = JSON.parse(e.features[0].properties.store)
				this.activeStore = e.features[0].properties
				this.showSlide = false

				while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
					coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
				}

				this.map.flyTo({
					center: coordinates,
					offset: [0, -100],
					zoom: 20,
					bearing: 0,
					speed: 1.1, 
					curve: 1.2, 
					easing: (x) => x * x * x,
					essential: true
				});

				this.popup
					.setLngLat(coordinates)
					.setDOMContent(this.$refs.popup)
					.setOffset(20)
					.addTo(this.map)  
			});

			this.map.on('mouseenter', 'clusters', () => {
				this.map.getCanvas().style.cursor = 'pointer';
			});
			this.map.on('mouseleave', 'clusters', () => {
				this.map.getCanvas().style.cursor = '';
			});
			this.map.on('mouseenter', 'unclustered-point', () => {
				this.map.getCanvas().style.cursor = 'pointer';
			});
			this.map.on('mouseleave', 'unclustered-point', () => {
				this.map.getCanvas().style.cursor = '';
			});
		},
		openPopup(store) {
			this.activeStore = store
			let mapData = JSON.parse(this.activeStore.map_data);

			this.map.flyTo({
				center: mapData.geometry.coordinates,
				offset: [0, -100],
				zoom: 20,
				bearing: 0,
				speed: 1.1, 
				curve: 1.2, 
				easing: (t) => t,
				essential: true
			});

			this.showSlide = false
			this.popup
				.setLngLat(mapData.geometry.coordinates)
				.setDOMContent(this.$refs.popup)
				/* .setOffset(70) */
				.addTo(this.map);

		},
		getStoresCategories() {
			this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/store_category' )
				.then( res => {
					this.categories = res.data.filter(cat => cat.count > 0)

					//Add store markers to map image list
					this.categories.forEach(cat => {		
						this.map.loadImage(cat.data.fields.marker.url, (error, image) => {
							if (error) throw error;
							this.map.addImage( cat.id, image);
						})
						/* this.map.loadImage(cat.data.fields.marker_on_select.url, (error, image) => {
							if (error) throw error;
							this.map.addImage( cat.slug, image);
						})  */
					})
				}
			);
        },
		showMenuCategory(category) {
			if ( this.activeMenuCategory === category ) {
				this.activeMenuCategory = false
			} else {
				this.activeMenuCategory = category
			}
		},
		getPlacesCount(category) {
			let places = []
			let count = 0
			if ( category.id ) {
				places = this.blockData.map.markers.filter(marker => marker.select === 'Store' && marker.store[0].store_categories[0].term_id === category.id )
			}
			if ( this.searchQuery !== "" ) {
				let regex = new RegExp('(' +this.searchQuery + ')', 'i')
				places = this.blockData.map.markers.filter(marker => marker.select === 'Store' && marker.store[0].post_title.match(regex) &&  marker.store[0].store_categories[0].term_id === category.id)

			}
			// count = places.length === 1 ? places.length + ' ' + this.__('Place', 'ccave') : places.length + ' ' + this.__('Places', 'ccave')
			count = places.length 
			return count

		},
		categoryPlaces (categoryId) {
			let places = []
			if ( categoryId ) {
				places = this.blockData.map.markers.filter(marker => marker.select === 'Store' && marker.store[0].store_categories[0].term_id === categoryId )
			}
			if( this.searchQuery !== "" ) {
				places = places.filter(place => {
					let regex = new RegExp('(' +this.searchQuery + ')', 'i');
					return place.store[0].post_title.match(regex)
				})
            }
			return places
		},
		showStoreSlide(){
			if ( this.$refs.slideCard.classList.contains('invisible') && !this.showSlide) {
				this.$refs.slideCard.style.visibility = 'visible'

				this.showSlide = true
				this.popup.remove()

				this.$nextTick( ()=>{ this.slideSlider = new Swiper( this.$refs.slideSlider, this.slideSliderOptions ) } )

				let offsetCard
                if ( this.$root.isMobile ){
                    offsetCard = -67 
                } else{
                    offsetCard = -116 
                }

                this.$root.scroll.scrollTo('#storeMap', {
                    offset: offsetCard,
                    duration: 800,
                    disableLerp: true
                })

			}
        },
		hideStoreSlide() {
			setTimeout(() => {
				this.$refs.slideCard.style.visibility = 'hidden'
			}, 500);
			this.showSlide = false
        },
		getDay() {
			let returnStr = ''

			const today = new Date()
			const timeZone = "Europe/Montenegro"
			const utcDate = zonedTimeToUtc(today, timeZone)
			let dayOfWeek = getDay(utcDate)

			switch (dayOfWeek) {
				case 1: // Monday
						returnStr = this.formatTime(this.activeStore.store[0].fields.work_hours['monday'].open) + ' - ' + this.formatTime(this.activeStore.store[0].fields.work_hours['monday'].close)
						this.activeDayHours = this.activeStore.store[0].fields.work_hours['monday']
						break;
				case 2: // Tuesday
						returnStr = this.formatTime(this.activeStore.store[0].fields.work_hours['tuesday'].open) + ' - ' + this.formatTime(this.activeStore.store[0].fields.work_hours['tuesday'].close)
						this.activeDayHours = this.activeStore.store[0].fields.work_hours['tuesday']
						break;
				case 3: // Wednesday
						returnStr = this.formatTime(this.activeStore.store[0].fields.work_hours['wednesday'].open) + ' - ' + this.formatTime(this.activeStore.store[0].fields.work_hours['wednesday'].close)
						this.activeDayHours = this.activeStore.store[0].fields.work_hours['wednesday']
						break;
				case 4: // Thursday
						returnStr = this.formatTime(this.activeStore.store[0].fields.work_hours['thursday'].open) + ' - ' + this.formatTime(this.activeStore.store[0].fields.work_hours['thursday'].close)
						this.activeDayHours = this.activeStore.store[0].fields.work_hours['thursday']
						break;
				case 5: // Friday
						returnStr = this.formatTime(this.activeStore.store[0].fields.work_hours['friday'].open) + ' - ' + this.formatTime(this.activeStore.store[0].fields.work_hours['friday'].close)
						this.activeDayHours = this.activeStore.store[0].fields.work_hours['friday']
						break;
				case 6: // Saturday
						returnStr = this.formatTime(this.activeStore.store[0].fields.work_hours['saturday'].open) + ' - ' + this.formatTime(this.activeStore.store[0].fields.work_hours['saturday'].close)
						this.activeDayHours = this.activeStore.store[0].fields.work_hours['saturday']
						break;
				case 0: // Sunday
						returnStr =  this.formatTime(this.activeStore.store[0].fields.work_hours['sunday'].open) + ' - ' + this.formatTime(this.activeStore.store[0].fields.work_hours['sunday'].close)
						this.activeDayHours = this.activeStore.store[0].fields.work_hours['sunday']
						break;
				default:
						returnStr = ""
			}
			return returnStr
        },
		getStoreStatus() {
			if (this.activeDayHours) {
				let openTime = this.activeDayHours.open
				let closeTime = this.activeDayHours.close

				const today = new Date()
				const timeZone = "Europe/Montenegro"
				const utcDate = zonedTimeToUtc(today, timeZone)

				let s =  openTime.split(':');
				let dt1 = new Date(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate(), parseInt(s[0]), parseInt(s[1]), parseInt(s[2]));
				let e =  closeTime.split(':');
				let dt2 = new Date(utcDate.getFullYear(), utcDate.getMonth(),utcDate.getDate(), parseInt(e[0]), parseInt(e[1]), parseInt(e[2]));

				if ( this.activeDayHours.openedclosed ) {
					return (utcDate >= dt1 && utcDate <= dt2) ? this.__('Open Now:', 'ccave') : this.__('Closed Now', 'ccave')
				} else {
					return this.__('Closed Now', 'ccave')
				}
			}
        },
		isStoreOpen(day) {
                let open = this.activeStore.store[0].fields.work_hours[day].openedclosed ? true : false
                return open
            },
		formatTime(time) {
			const today = new Date()
			const timeZone = "Europe/Montenegro"
			const utcDate = zonedTimeToUtc(today, timeZone)

			let s =  time.split(':');
			let dt1 = new Date(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate(), parseInt(s[0]), parseInt(s[1]), parseInt(s[2]));
			return format( dt1, 'hh a')
        },
		closeSidebar() {
			if ( this.$root.isMobile ) {
				this.showSidebar = false
			}
		},
		getSearchString() {
            return this.__('Search...', 'ccave')
        },
		ifWorkHours(activeStore) {
			let workHours = activeStore.store[0].fields.work_hours
			if (
				!workHours.monday.openedclosed &&
				!workHours.tuesday.openedclosed &&
				!workHours.wednesday.openedclosed &&
				!workHours.thursday.openedclosed &&
				!workHours.friday.openedclosed &&
				!workHours.saturday.openedclosed &&
				!workHours.sunday.openedclosed 
			) {	return false } else { return true }
		}
	}
};
</script>

<style scoped>
.map {
	position: absolute;
	left: 33.3333%;
	width: 66.6666%;
	top: 0;
	bottom: 0;
}


#map-style {
	position: absolute;
	width: 20%;
	height: 10%;
	top: 360px;
	left: 942px;
	overflow: hidden;
	z-index: 1;
}

</style>
